import React from "react"

import {Raw} from "~/components/raw"

import styles from "./index.module.css"

export interface AkkreditElements {
  NAME: string;
  LINK_FILE: string;
}

interface List {
  element: AkkreditElements[]
}

export const List: React.FC<List> = (list) => {
  return (
    <>
      {list.element.map((item, index) => {
        return (
          <div className={styles.Text} key={index}>
            <a
              className={styles.Link}
              href={item.LINK_FILE}
              rel="noopener noreferrer"
              target="_blank"
            >
              <Raw html={item.NAME}/>
            </a>
          </div>
        )
      })}
    </>
  )
}